import { render, staticRenderFns } from "./BadgeReason.vue?vue&type=template&id=2a44a4c6&"
import script from "./BadgeReason.vue?vue&type=script&lang=js&"
export * from "./BadgeReason.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports